import { useRef } from "react";
import { useEditDriverMutation } from "./driverSlice";
import { useGetWardsQuery } from "../wards/wardSlice";

const DriverEdit = ({ refOpen, editData, setEditData }) => {
      const {
            data: wards,
            isSuccess,
            isError,
            error
        } = useGetWardsQuery('getWards');

    const [editDriverData, { isLoading }] = useEditDriverMutation()


    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value })
    }
    const refCloseDriver = useRef(null)

    const handleClick = async (e) => {
        e.preventDefault()
        try {
            refCloseDriver.current.click();
            await editDriverData({ p_id: editData?.p_id, p_name: editData?.p_name, p_email: editData?.p_email, is_leave: editData?.is_leave, is_blocked: editData?.is_blocked, p_ward_id: editData?.p_ward_id }).unwrap()
            setEditData({ p_id: "", p_name: "", p_email: "", is_leave: "", is_blocked: "", p_ward_id: "" });
        }
        catch (e) {
            console.error("Error in community edit", e)
        }
    }
    return (
        <>
            <button ref={refOpen} type="button" className="btn d-none" data-bs-toggle="offcanvas" data-bs-target="#depOffCanvas1" aria-controls="depOffCanvas1"></button>

            <div className="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="depOffCanvas1" aria-labelledby="depOffCanvas1">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit Inc</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref={refCloseDriver}></button>
                </div>
                <div className="offcanvas-body">
                    <div>
                        <form className="row g-3">
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="community_name"
                                    name="p_name"
                                    value={editData?.p_name}
                                    onChange={handleChange}
                                    placeholder="Name"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="community_name"
                                    name="p_email"
                                    value={editData?.p_email}
                                    onChange={handleChange}
                                    placeholder="Email"
                                    autoComplete="off"
                                    required
                                />
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Leave
                                </label>
                                <select className="form-select"
                                    value={editData?.is_leave}
                                    onChange={handleChange}
                                    id="community_type" name="is_leave" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    Blocked
                                </label>
                                <select className="form-select"
                                    value={editData?.is_blocked}
                                    onChange={handleChange}
                                    id="community_type" name="is_blocked" required>
                                    <option value="">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                            <div className="col-md-12 text-left">
                                <label htmlFor="ename" className="form-label font-weight-bold">
                                    ward id
                                </label>
                                <select className="form-select"
                                    value={editData?.p_ward_id}
                                    onChange={handleChange}
                                    id="community_type" name="p_ward_id" required>
                                    <option value="">--Select--</option>
                                    {/* <option value="4cd2">50</option>
                                    <option value="a0f5">93</option> */}
                                     {wards?.ids?.map((e) => {
                                        return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                                    })}
                                </select>
                            </div>

                            <div className="col-md-12">
                                <button type="submit" className="btn btn-ff9b44 btn-block btn-round"
                                    onClick={handleClick}
                                >
                                    {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DriverEdit